<form [formGroup]="addressForm" class="was-validated">
  <div class="auto-complete-with-map-container">
    <div class="autocomplete-label">
      <label class="text-input-label">{{ addressLabelText }}</label>
    </div>
    <div class="autocomplete-container">
      <p-autoComplete
        formControlName="address"
        [suggestions]="filteredAddresses$ | async"
        (completeMethod)="filterAddress($event)"
        (onSelect)="addressSelected($event?.value)"
        field="fullAddress"
        styleClass="address-autocomplete"
        [forceSelection]="true"
        placeholder="Ex.: 177a Bleecker Street, New York, NY, USA"
        #autocomplete
      >
        <ng-template let-address pTemplate="item">
          <div class="flex align-items-center gap-2">
            <mat-icon svgIcon="location_on"></mat-icon>
            <div class="w-10">{{ address.fullAddress }}</div>
          </div>
        </ng-template>
      </p-autoComplete>
      <mat-error
        class="autocomplete-error"
        *ngIf="
          addressForm.touched && addressForm.get('address').hasError('required')
        "
      >
        {{ requiredErrorText }}
      </mat-error>
      <label
        class="sublabel"
        *ngIf="
          (addressForm.touched &&
            !addressForm.get('address').hasError('required')) ||
          !addressForm.touched
        "
        >{{ addressSubLabelText }}</label
      >
    </div>

    <label class="text-input-label second-line-of-address-label">
      Second line of address (Optional)</label
    >
    <mat-form-field appearance="outline" class="second-line-of-address-input">
      <input
        formControlName="street2Name"
        matInput
        class="lo_sensitive capitalize"
        placeholder="Example: apt, floor, unit etc"
      />
    </mat-form-field>

    <div #mapContainer class="map-container" *ngIf="shouldShowMap"></div>
  </div>
</form>
